import { hot } from 'react-hot-loader/root'
import React from 'react'
import PropTypes from 'prop-types'
import { IntlProvider } from 'react-intl'
import { EPProvider } from '@elparking/components'
import convertConstantToEPProviderFormat from 'commons/js/util/coverterGlobalConfig'

import { messages } from 'commons/js/messages'
import { defaultLocale, currentLocale } from 'commons/js/locale'

import StickyTabsContainer from './containers/StickyTabsContainer'

import theme from './theme'

const App = ({ elements, tabs }) => (
    <IntlProvider
      locale={currentLocale}
      defaultLocale={defaultLocale}
      messages={messages[currentLocale]}
    >
        <EPProvider theme={theme} {...convertConstantToEPProviderFormat()}>
            <StickyTabsContainer
              elements={elements}
              tabs={tabs}
              defaultTabName={elements && elements[0] && elements[0].name}
            />
        </EPProvider>
    </IntlProvider>
)

App.propTypes = {
    tabs: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            href: PropTypes.string,
        }),
    ),
    elements: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            target: PropTypes.object,
        }),
    ),
}

export default hot(App)
